import { z } from 'zod';

export const campaignFormSchema = z
  .object({
    title: z.string().trim().min(2, 'Heading is required').max(80, 'Heading is too long'),
    message: z.string().trim().min(2, 'Message is required').max(500, 'Message is too long'),
    scope: z.enum(['all', 'campus']),
    campusIds: z.array(z.string()),
    scheduleMode: z.enum(['now', 'later']),
    // datetime-local string, e.g. "2026-08-04T14:30".
    sendAt: z.string().optional(),
  })
  .superRefine((values, ctx) => {
    if (values.scope === 'campus' && values.campusIds.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['campusIds'],
        message: 'Select at least one campus',
      });
    }
    if (values.scheduleMode === 'later') {
      if (!values.sendAt) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['sendAt'],
          message: 'Pick a date and time',
        });
      } else if (new Date(values.sendAt).getTime() <= Date.now()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['sendAt'],
          message: 'Schedule time must be in the future',
        });
      }
    }
  });

export type CampaignFormValues = z.infer<typeof campaignFormSchema>;
